import { render, staticRenderFns } from "./UserEditTabCategories.vue?vue&type=template&id=e33e666e&"
import script from "./UserEditTabCategories.vue?vue&type=script&lang=js&"
export * from "./UserEditTabCategories.vue?vue&type=script&lang=js&"
import style0 from "./UserEditTabCategories.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports